import { render, staticRenderFns } from "./PayAuthorityInfo.vue?vue&type=template&id=2b886901&scoped=true&"
import script from "./PayAuthorityInfo.vue?vue&type=script&lang=ts&"
export * from "./PayAuthorityInfo.vue?vue&type=script&lang=ts&"
import style0 from "./PayAuthorityInfo.vue?vue&type=style&index=0&id=2b886901&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b886901",
  null
  
)

export default component.exports